import { z } from 'zod';
import { validateDateRange } from '@/shared/forms/PositionSettingsForm/utils/validateDateRange.ts';

export type PositionSettingsFormRules = {
    dateRange?: { validFrom: string; validTo: string };
};

export function getPositionSettingsFormSchema({
    formRules,
    errorMessages,
}: {
    formRules?: PositionSettingsFormRules;
    errorMessages?: {
        required?: string;
        dateRange?: {
            validFrom?: string;
            validTo?: string;
        };
    };
}) {
    return z.object({
        active: z.boolean({
            required_error: errorMessages?.required,
        }),
        dateRange: z.object({
            validFrom: z.coerce
                .date({
                    required_error: errorMessages?.required,
                })
                .refine(validateDateRange(formRules?.dateRange), errorMessages?.dateRange?.validFrom),
            validTo: z.coerce
                .date({
                    required_error: errorMessages?.required,
                })
                .refine(validateDateRange(formRules?.dateRange), errorMessages?.dateRange?.validTo),
        }),
        note: z.string().optional(),
    });
}

export type PositionSettingsFormValues = z.infer<ReturnType<typeof getPositionSettingsFormSchema>>;
